import { HourlyTempRH } from './wxCharts/HourlyTempRH';
import React, { useCallback, useState, useEffect } from 'react';
import { useStoreContext } from '../../../../store/context';
import { alertMessages } from '../../../../constants';
import { useAddAlert, usePopUpContent } from '../../../../store/actions';
import { PrecipOrSRHourly } from './wxCharts/PrecipOrSRHourly';
import { WindHourlyChart } from './wxCharts/WindHourlyChart';
import {SFChart} from './wxCharts/SFChart';
import moment from 'moment';
import {ONEDAY, ONEMIN,ONESEC, errorResponse} from '../../../../store/common';
import { getWeatherMinMax, getWeatherObsStations } from 'src/apis/getWeatherCalls';
import { MaxTempRH } from './wxCharts/MaxTempRH';
import { MinTempRH } from './wxCharts/MinTempRH';
import { WindMaxChart } from './wxCharts/WindMaxChart';
import { SRDailyChart } from './wxCharts/DailySR';
import {SFHourly} from './wxCharts/SFHourly';
import { DoubleVars } from './nfdrCharts/DoubleVars';
import { getNfdrHourly, getNfdrMinMax } from 'src/apis/getNfdrsCalls';
import { SingleVars } from './nfdrCharts/SingleVars';

interface PlotProps{
    id: any;
	stationMeta:any;
}

export const ChartPopUpWXNfdrs: React.FC<PlotProps> = ({
  id, stationMeta
}) =>{
  const [ state, dispatch ] = useStoreContext();
  const addAlert = useAddAlert(dispatch);
  const setContent = usePopUpContent(dispatch);
  const [ allVars, setAllVars ] = useState<any[]>([]);
  const [nfdrsDailyFailCount, setNfdrsDailyFailCount] = useState<number>(0);
  const [nfdrsHourlyFailCount, setNfdrsHourlyFailCount] = useState<number>(0);

  const [wxDailyFailCount, setWxDailyFailCount] = useState<number>(0);
  const [wxHourlyFailCount, setWxHourlyFailCount] = useState<number>(0);

  
	/* weatherObsResponse will format the data to date as a number, values on the chart as numbers, and offset of number for timezone*/
	const weatherObsResponse = useCallback((response:any[], chartType: string) =>{
		let all_vars:any[]=[];
		const utcOffset: string = stationMeta?.time_zone_offset.toString();
		if(response?.length===0){
			setAllVars([])
		}
		else if(chartType==="Hourly_Temp_RH"){
		  all_vars=[]
		  response.forEach((item: any)=>{
			if(item.observation_type === 'O'){
			  all_vars.push({
				date: Number(moment(item.observation_time_lst).format('x')),
				rhvalsObs: item["relative_humidity"],
				tempObs: item["temperature"],
				offset: Number(utcOffset)*60
			  })
			}
			else{
				all_vars.push({
					date: Number(moment(item.observation_time_lst).format('x')),
					rhvalsF: item["relative_humidity"],
					tempF: item["temperature"],
					offset: Number(utcOffset)*60
				  })
			}
			return item;
		  }); 
		  const allVars = all_vars.toSorted(({date:a}, {date:b})=>b-a)
		  setAllVars(allVars);
	    }
	    else if(chartType==="Hourly_Precipitation"|| chartType==="Hourly_Solar_Radiation"){      
		all_vars=[];
		response.forEach((item: any)=>{
			if(state.chartTable.value==="Hourly_Precipitation"){
				if(item.observation_type === 'O'){
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						valObs:item['hourly_precip'],					
						offset: Number(utcOffset)*60
					})
				}
				else{
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						valF:item['hourly_precip'],
						offset: Number(utcOffset)*60
					})
				}
			}
			else if(state.chartTable.value==="Hourly_Solar_Radiation"){
				if(item.observation_type === 'O'){
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						valObs:item['sol_rad'],
						offset: Number(utcOffset)*60
					})
				}
				else{
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						valF:item['sol_rad'],
						offset: Number(utcOffset)*60
					})
				}
			}
			return item;
		});        
		const allVars = all_vars.toSorted(({date:a}, {date:b})=>b-a)
		setAllVars(allVars);    	
	}
	    else if(chartType ===('Hourly_Snow_Flag')){
		all_vars=[];
		response.forEach((item: any)=>{	
			if(item.observation_type === 'O'){
				  if(item["snow_flag"]?.toString().includes('Y')){
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						valObs: 1,
						offset: Number(utcOffset)*60
					})
					
				  }
				  else{
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						valObs: 0,
						offset: Number(utcOffset)*60
					})
				  }
			}
			else{
				if(item["snow_flag"]?.toString().includes('Y')){
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						valF: 1,
						offset: Number(utcOffset)*60
					})
					
				}else{
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						valF: 0,
						offset: Number(utcOffset)*60
					})
				  }
			}
			return item;
		});        
		const allVars = all_vars.toSorted(({date:a}, {date:b})=>b-a)
		setAllVars(allVars);
    	}
		else if(chartType==="Hourly_Wind") 
		{
			all_vars=[];
			response.forEach((item: any)=>{
			
			if(item.observation_type === 'O'){
				all_vars.push({
					date: Number(moment(item.observation_time_lst).format('x')),
					obsWS: item["wind_speed"],
					obsGS: item["peak_gust_speed"],
					windDir: item["wind_direction"],
					offset: Number(utcOffset)*60

				})
				
			}
			else{
				all_vars.push({
					date: Number(moment(item.observation_time_lst).format('x')),
					fcWS: item["wind_speed"],
					fcGS: item["peak_gust_speed"],
					windDir: item["wind_direction"],
					offset: Number(utcOffset)*60
				})
			}
			return item;
			}); 
			const allVars = all_vars.toSorted(({date:a}, {date:b})=>b-a)
			setAllVars(allVars);
		}
		else{
			//single line
			all_vars = [];
			response.forEach((item: any) => {

				if (item.observation_type === 'O') {
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						obs: item[`${state.chartTable.value}`],
						offset: Number(utcOffset) * 60

					})

				}
				else {
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						forecast: item[`${state.chartTable.value}`],
						offset: Number(utcOffset) * 60
					})
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => b - a)
			setAllVars(allVars);
		}
	},[ state.chartTable.value, stationMeta?.time_zone_offset]);

	/* weatherDailyResponse will format the data to date as a number, values on the chart as numbers, and offset of number for timezone*/
	const weatherDailyResponse = useCallback((response:any, chartType: string)=>{
		let all_vars:any[]=[];
		const utcOffset: string = stationMeta?.time_zone_offset.toString();

		const todaysDate = moment().format('YYYY-MM-DD');
		if(response?.length===0){
			setAllVars([])
		}
		else if(chartType==="Max_Temp_Min_RH"){
		  all_vars=[]
		  response.forEach((item: any)=>{
			if(item.observation_type === 'O'){
			  all_vars.push({
				date: Number(moment(item.summary_date).format('x')),
				rhvalsObs: item["relative_humidity_min"],
				tempObs: item["temperature_max"],
				offset: Number(utcOffset)*60
			  })
			}
			else{
				if(todaysDate === item.summary_date){
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						rhvalsObs: item["relative_humidity_min"],
						tempObs: item["temperature_max"],
						offset: Number(utcOffset)*60
					})
				}
				all_vars.push({
					date: Number(moment(item.summary_date).format('x')),
					rhvalsF: item["relative_humidity_min"],
					tempF: item["temperature_max"],
					offset: Number(utcOffset)*60
				  })
			}
			return item;
		  }); 
		  const allVars = all_vars.toSorted(({date:a}, {date:b})=>a-b);
		  setAllVars(allVars);
	    }
		else if(chartType==="Min_Temp_Max_RH"){
			all_vars=[]
			response.forEach((item: any)=>{
			  if(item.observation_type === 'O'){
				all_vars.push({
				  date: Number(moment(item.summary_date).format('x')),
				  rhvalsObs: item["relative_humidity_max"],
				  tempObs: item["temperature_min"],
				  offset: Number(utcOffset)*60
				})
			  }
			  else{
				if(todaysDate === item.summary_date){
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						rhvalsObs: item["relative_humidity_max"],
						tempObs: item["temperature_min"],
						offset: Number(utcOffset)*60
					})
				}
				  all_vars.push({
					  date: Number(moment(item.summary_date).format('x')),
					  rhvalsF: item["relative_humidity_max"],
					  tempF: item["temperature_min"],
					  offset: Number(utcOffset)*60
					})
			  }
			  return item;
			}); 
			const allVars = all_vars.toSorted(({date:a}, {date:b})=>a-b);
			setAllVars(allVars);
		  }
		else if(chartType==="Max_Wind"){
			all_vars=[]
			response.forEach((item: any)=>{
			  if(item.observation_type === 'O'){
				all_vars.push({
				  date: Number(moment(item.summary_date).format('x')),
				  maxSpeedObs: item["wind_speed_max"],
				  maxGustObs: item["peak_gust_speed_max"],
				  gustDir: item["peak_wind_gust_direction"],
				  offset: Number(utcOffset)*60
				})
			  }
			  else{
				if(todaysDate === item.summary_date){
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						maxSpeedObs: item["wind_speed_max"],
						maxGustObs: item["peak_gust_speed_max"],
						gustDir: item["peak_wind_gust_direction"],
						offset: Number(utcOffset)*60
					  })
				}
				  all_vars.push({
					  date: Number(moment(item.summary_date).format('x')),
					  maxSpeedF: item["wind_speed_max"],
					  maxGustF: item["peak_gust_speed_max"],
					  gustDir: item["peak_wind_gust_direction"],
					  offset: Number(utcOffset)*60
					})
			  }
			  return item;
			}); 
			const allVars = all_vars.toSorted(({date:a}, {date:b})=>a-b);
			setAllVars(allVars);
		}
		else if(chartType==="Daily_Solar_Radiation"){
			all_vars=[]
			response.forEach((item: any)=>{
			  if(item.observation_type === 'O'){
				all_vars.push({
				  date: Number(moment(item.summary_date).format('x')),
				  valObs: item["solar_radiation_max"],
				  offset: Number(utcOffset)*60
				})
			  }
			  else{
				if(todaysDate === item.summary_date){
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						valObs: item["solar_radiation_max"],
						offset: Number(utcOffset)*60
					  })
				}
				  all_vars.push({
					  date: Number(moment(item.summary_date).format('x')),
					  valF: item["solar_radiation_max"],
					  offset: Number(utcOffset)*60
					})
			  }
			  return item;
			}); 
			const allVars = all_vars.toSorted(({date:a}, {date:b})=>a-b);
			setAllVars(allVars);
		}
		else if(chartType==="Daily_Precip"){
			all_vars=[]
			response.forEach((item: any)=>{
			  if(item.observation_type === 'O'){
				all_vars.push({
				  date: Number(moment(item.summary_date).format('x')),
				  valObs: item["daily_precipitation_total"],
				  offset: Number(utcOffset)*60
				})
			  }
			  else{
				if(todaysDate === item.summary_date){
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						valObs: item["daily_precipitation_total"],
						offset: Number(utcOffset)*60
					})
				}
				  all_vars.push({
					  date: Number(moment(item.summary_date).format('x')),
					  valF: item["daily_precipitation_total"],
					  offset: Number(utcOffset)*60
					})
			  }
			  return item;
			}); 
			const allVars = all_vars.toSorted(({date:a}, {date:b})=>a-b);
			setAllVars(allVars);
		}
		else if (chartType === "Snow_Flag") {
			all_vars = []
			response.forEach((item: any) => {
				if (item.observation_type === 'O') {
					if (item["snow_flag"]?.toString().includes('Y')) {
						all_vars.push({
							date: Number(moment(item.summary_date).format('x')),
							valObs: 1,
							offset: Number(utcOffset) * 60
						})

					}
					else {

						all_vars.push({
							date: Number(moment(item.summary_date).format('x')),
							valObs: 0,
							offset: Number(utcOffset) * 60
						})
					}
				}
				else {
					if (item["snow_flag"]?.toString().includes('Y')) {
						if (todaysDate === item.summary_date) {
							all_vars.push({
								date: Number(moment(item.summary_date).format('x')),
								valObs: 1,
								offset: Number(utcOffset) * 60
							})
						}
						all_vars.push({
							date: Number(moment(item.summary_date).format('x')),
							valF: 1,
							offset: Number(utcOffset) * 60
						})

					} else {
						if (todaysDate === item.summary_date) {
							all_vars.push({
								date: Number(moment(item.summary_date).format('x')),
								valObs: 0,
								offset: Number(utcOffset) * 60
							})
						}
						all_vars.push({
							date: Number(moment(item.summary_date).format('x')),
							valF: 0,
							offset: Number(utcOffset) * 60
						})
					}
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => a - b);
			setAllVars(allVars);
		}
		else{
			// 2 vars - vpd
			all_vars = [];
			response.forEach((item: any) => {
				if (item.observation_type === 'O') {
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						var1Obs: item[`${state.chartTable.data1Name}`],
						var2Obs: item[`${state.chartTable.data2Name}`],
						offset: Number(utcOffset) * 60
					})

				}
				else {
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						var1F: item[`${state.chartTable.data1Name}`],
						var2F: item[`${state.chartTable.data2Name}`],
						offset: Number(utcOffset) * 60
					})
					if(todaysDate === item.summary_date){
						all_vars.push({
							date: Number(moment(item.summary_date).format('x')),
							var1Obs: item[`${state.chartTable.data1Name}`],
							var2Obs: item[`${state.chartTable.data2Name}`],
							offset: Number(utcOffset) * 60
						})
					}
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => b - a)
			setAllVars(allVars);
		}
	},[state.chartTable, stationMeta?.time_zone_offset]);

	/*nfdrObsResponse will format the data to date as a number, values on the chart as numbers, and offset of number for timezone*/
	const nfdrObsResponse = useCallback((response: any[], chartType: string) => {
		let all_vars: any[] = [];

		const utcOffset: string = stationMeta?.time_zone_offset.toString();
		if(response?.length===0){
			setAllVars([])
		}
		else if (chartType === "1_10_FM") {
			all_vars = []
			response.forEach((item: any) => {
				if (item.nfdr_type === 'O') {
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						oneHrObs: item["one_hr_tl_fuel_moisture"],
						tenHrObs: item["ten_hr_tl_fuel_moisture"],
						offset: Number(utcOffset) * 60
					})
				}
				else {
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						oneHrF: item["one_hr_tl_fuel_moisture"],
						tenHrF: item["ten_hr_tl_fuel_moisture"],
						offset: Number(utcOffset) * 60
					})
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => b - a)
			setAllVars(allVars);
		}
		else if (chartType === "100_1000_FM") {
			all_vars = []
			response.forEach((item: any) => {
				if (item.nfdr_type === 'O') {
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						hunHrObs: item["hun_hr_tl_fuel_moisture"],
						thouHrObs: item["thou_hr_tl_fuel_moisture"],
						offset: Number(utcOffset) * 60
					})
				}
				else {
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						hunHrF: item["hun_hr_tl_fuel_moisture"],
						thouHrF: item["thou_hr_tl_fuel_moisture"],
						offset: Number(utcOffset) * 60
					})
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => b - a)
			setAllVars(allVars);
		}
		else if (chartType === "herb_woody") {
			all_vars = [];
			response.forEach((item: any) => {
				if (item.nfdr_type === 'O') {
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						herbObs: item["herbaceous_lfi_fuel_moisture"],
						woodyObs: item["woody_lfi_fuel_moisture"],
						offset: Number(utcOffset) * 60
					})
				}
				else {
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						herbF: item["herbaceous_lfi_fuel_moisture"],
						woodyF: item["woody_lfi_fuel_moisture"],
						offset: Number(utcOffset) * 60
					})
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => b - a)
			setAllVars(allVars);
		}
		else{
			all_vars = [];
			response.forEach((item: any) => {

				if (item.nfdr_type === 'O') {
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						obs: item[`${state.chartTable.value}`],
						offset: Number(utcOffset) * 60

					})

				}
				else {
					all_vars.push({
						date: Number(moment(item.observation_time_lst).format('x')),
						forecast: item[`${state.chartTable.value}`],
						offset: Number(utcOffset) * 60
					})
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => b - a)
			setAllVars(allVars);
		}
	}, [state.chartTable.value, stationMeta?.time_zone_offset]);

	/* nfdrDailyResponse will format the data to date as a number, values on the chart as numbers, and offset of number for timezone*/
	const nfdrDailyResponse = useCallback((response: any, chartType: string) => {
		let all_vars: any[] = [];
		const todaysDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
		if(response?.length===0){
			setAllVars([])
		}
		else if (chartType === "1_10_FM_min") {
			all_vars = []
			response.forEach((item: any) => {
				if (item.nfdr_type === 'O') {
					if(todaysDate === item.summary_date){
						all_vars.push({
							date: Number(moment(item.summary_date).format('x')),
							oneHrF: item["one_hr_tl_fuel_moisture_min"],
							tenHrF: item["ten_hr_tl_fuel_moisture_min"],
							offset: Number(stationMeta.time_zone_offset) * 60
						})
					}
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						oneHrObs: item["one_hr_tl_fuel_moisture_min"],
						tenHrObs: item["ten_hr_tl_fuel_moisture_min"],
						offset: Number(stationMeta.time_zone_offset) * 60
					})
				}
				else {
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						oneHrF: item["one_hr_tl_fuel_moisture_min"],
						tenHrF: item["ten_hr_tl_fuel_moisture_min"],
						offset: Number(stationMeta.time_zone_offset) * 60
					})
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => b - a)
			setAllVars(allVars);
		}
		else if (chartType === "100_1000_FM_min") {
			all_vars = []
			response.forEach((item: any) => {
				if (item.nfdr_type === 'O') {
					if(todaysDate === item.summary_date){
						all_vars.push({
							date: Number(moment(item.summary_date).format('x')),
							hunHrF: item["hun_hr_tl_fuel_moisture_min"],
							thouHrF: item["thou_hr_tl_fuel_moisture_min"],
							offset: Number(stationMeta.time_zone_offset) * 60
						})
					}
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						hunHrObs: item["hun_hr_tl_fuel_moisture_min"],
						thouHrObs: item["thou_hr_tl_fuel_moisture_min"],
						offset: Number(stationMeta.time_zone_offset) * 60
					})
				}
				else {
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						hunHrF: item["hun_hr_tl_fuel_moisture_min"],
						thouHrF: item["thou_hr_tl_fuel_moisture_min"],
						offset: Number(stationMeta.time_zone_offset) * 60
					})
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => b - a)
			setAllVars(allVars);
		}
		else if (chartType === "herb_woody_max") {
			all_vars = [];
			response.forEach((item: any) => {
				if (item.nfdr_type === 'O') {
					if(todaysDate === item.summary_date){
						all_vars.push({
							date: Number(moment(item.summary_date).format('x')),
							herbF: item["herbaceous_lfi_fuel_moisture"],
							woodyF: item["woody_lfi_fuel_moisture"],
							offset: Number(stationMeta.time_zone_offset) * 60
						})
					}
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						herbObs: item["herbaceous_lfi_fuel_moisture"],
						woodyObs: item["woody_lfi_fuel_moisture"],
						offset: Number(stationMeta.time_zone_offset) * 60
					})
				}
				else {
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						herbF: item["herbaceous_lfi_fuel_moisture"],
						woodyF: item["woody_lfi_fuel_moisture"],
						offset: Number(stationMeta.time_zone_offset) * 60
					})
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => b - a)
			setAllVars(allVars);
		}
		else{
			all_vars = [];
			response.forEach((item: any) => {
				if (item.nfdr_type === 'O') {
					if(todaysDate === item.summary_date){
						all_vars.push({
							date: Number(moment(item.summary_date).format('x')),
							forecast: item[`${state.chartTable.value}`],
							offset: Number(stationMeta.time_zone_offset) * 60
						})
					}
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						obs: item[`${state.chartTable.value}`],
						offset: Number(stationMeta.time_zone_offset) * 60
					})

				}
				else {
					all_vars.push({
						date: Number(moment(item.summary_date).format('x')),
						forecast: item[`${state.chartTable.value}`],
						offset: Number(stationMeta.time_zone_offset) * 60
					})
				}
				return item;
			});
			const allVars = all_vars.toSorted(({ date: a }, { date: b }) => b - a)
			setAllVars(allVars);
		}
	}, [state.chartTable.value, stationMeta?.time_zone_offset]);

  	/*weatherCallback is for hourly charts*/
	const weatherCallBack = useCallback((chartType: string, counter:number) =>{
		(async()=>{
			try{
				const zeroedStartDate = moment(state.currentSliderDate - (4 * ONEDAY)).utc().hour(23).minute(30).second(0).millisecond(0)
				const varRequest = {
					stationId: id.toString(),
					zoomLevel: 5,
					startDate: zeroedStartDate,
					endDate: moment(state.currentSliderDate +(3*ONEDAY)+ (30*ONEMIN)-ONESEC ).utc().format(),
					page: 0,
					perPage: 100000,
				};
				const response: any = await getWeatherObsStations(varRequest, addAlert);
				if(response.data?.length>0){
				    setContent(response.data);
				    weatherObsResponse(response.data, chartType);
					setWxHourlyFailCount(0)
				}
				else{
					setContent([])
					setWxHourlyFailCount(counter+1)
				}
			}
			catch(error){
				console.log('error', error)
				setContent([])
				setWxHourlyFailCount(counter+1)
				errorResponse(error, addAlert, alertMessages.retrievingStationData)
			}
		})();
	},[addAlert,setContent, id, weatherObsResponse,state.currentSliderDate, setWxHourlyFailCount]);

	/*nfdrCallback is for hourly charts*/
	const nfdrCallback = useCallback((chartType: string, counter: number) => {
		(async () => {
			try {
				const varRequest = {
					stationIds: id.toString(),
					zoomLevel: 5,
					startDate: moment(state.currentSliderDate - (3 * ONEDAY) - (30 * ONEMIN)).utc().format('YYYY-MM-DD'),
					endDate: moment(state.currentSliderDate + (3 * ONEDAY) + (30 * ONEMIN) - ONESEC).utc().format('YYYY-MM-DD'),
					startHour: 0,
					endHour: 23,
					page: 0,
					perPage: 3000000,
					fuelModel: state.nfdrFuelModel,
					sortBy: 'observation_time',
					sortOrder: 'asc',
				};
				const response: any = await getNfdrHourly(varRequest, addAlert);
				if (response.data?.length>0) {
					setContent(response.data);
					nfdrObsResponse(response.data, chartType);
				}
				else{
					setContent([])
					setNfdrsHourlyFailCount(counter+1)
				}

			}
			catch (error) {
				console.log('error', error)
				setContent([])
				setNfdrsHourlyFailCount(counter+1)
				errorResponse(error, addAlert, alertMessages.retrievingStationData)
			}
		})();
	}, [addAlert, setContent, id, nfdrObsResponse, state.currentSliderDate, state.nfdrFuelModel
		,setNfdrsHourlyFailCount

	]);

	/*call to get weather min and max charts populated*/
	const weatherMinMaxCallback = useCallback((chartType:string, counter: number)=>{
		(async()=>{
			try{
				const requestVars={
					zoomLevel: 5, 
					startDate: moment(state.currentSliderDate -(3*ONEDAY)).utc().format('YYYY-MM-DD'),
					endDate: moment(state.currentSliderDate +(3*ONEDAY)).utc().format('YYYY-MM-DD'),
					stationIds: id.toString(),
					page:0,
					perPage: 100000,
				}
				const response:any = await getWeatherMinMax(requestVars, addAlert);
				if(response.data?.length>0){
					setContent(response.data);
					weatherDailyResponse(response.data, chartType)
					setWxDailyFailCount(0);
				}
				else{
					setContent([])
					setWxDailyFailCount(counter+1)
				}
				
			}
			catch(error){
				console.log('error', error)
				setContent([])
				setWxDailyFailCount(counter+1)
				errorResponse(error, addAlert, alertMessages.retrievingStationData)
			}
		})();
	},[addAlert,setContent, weatherDailyResponse,id, state.currentSliderDate, setWxDailyFailCount]);

	/*nfdrDailyCallback is for daily charts*/
	const nfdrDailyCallback = useCallback((chartType: string, counter: number) => {
		(async () => {
			try {
				const varRequest = {
					stationIds: id.toString(),
					zoomLevel: 5,
					startDate: moment(state.currentSliderDate - (3 * ONEDAY)).utc().format('YYYY-MM-DD'),
					endDate: moment(state.currentSliderDate + (3 * ONEDAY)).utc().format('YYYY-MM-DD'),
					fuelModel: state.nfdrFuelModel,
					page: 0,
					perPage: 300000,
				};
				const response: any = await getNfdrMinMax(varRequest, addAlert, state?.user);
				if (response?.length>0) {
					setContent(response);
					nfdrDailyResponse(response, chartType);
					setNfdrsDailyFailCount(0);
				}
				else{
					setContent([])
					setNfdrsDailyFailCount(counter+1)
				}
			}
			catch (error) {
				console.log('error', error)
				setContent([])
				setNfdrsDailyFailCount(counter+1)
				errorResponse(error, addAlert, alertMessages.retrievingStationData)
			}
		})();
	}, [addAlert, setContent, id, nfdrDailyResponse, state.currentSliderDate, state.nfdrFuelModel, state?.user]);

	/*useEffect to determine which call has to be made*/
	useEffect(()=>{
		if(state.selectedRadio.type==='hourly' && state.selectedRadio.dataType==='Weather' && state.mapDataType==='Weather' && stationMeta){

			weatherCallBack(state.chartTable.value, wxHourlyFailCount);
			const ref = setInterval(()=>{
				weatherCallBack(state.chartTable.value, wxHourlyFailCount);
			}, 300000);
			return () => {
				if(ref){
					clearInterval(ref);
				}
			}
		}
		if(state.selectedRadio.type==='daily' && state.selectedRadio.dataType==='Weather'&& state.mapDataType==='Weather'&& stationMeta){
			weatherMinMaxCallback(state.chartTable.value, wxDailyFailCount);
			const ref = setInterval(()=>{
				weatherMinMaxCallback(state.chartTable.value, wxDailyFailCount);
			}, 300000);
			return () => {
				if(ref){
					clearInterval(ref);
				}
			}
		}

		if(state.selectedRadio.type==='hourly' && state.selectedRadio.dataType==='FireDanger'&& state.mapDataType==='FireDanger' &&stationMeta){
			nfdrCallback(state.chartTable.value, nfdrsHourlyFailCount);
			const ref = setInterval(()=>{
				nfdrCallback(state.chartTable.value, nfdrsHourlyFailCount);
			}, 300000);
			return () => {
				if(ref){
					clearInterval(ref);
				}
			}
		}

		if(state.selectedRadio.type==='daily' && state.selectedRadio.dataType==='FireDanger'&& state.mapDataType==='FireDanger' && stationMeta){
			nfdrDailyCallback(state.chartTable.value, nfdrsDailyFailCount);
			const ref = setInterval(()=>{
				nfdrDailyCallback(state.chartTable.value, nfdrsDailyFailCount);
			}, 300000);
			return () => {
				if(ref){
					clearInterval(ref);
				}
			}
		}
	  },[weatherCallBack, state.chartTable.value, state.selectedRadio.type, weatherMinMaxCallback, state.selectedRadio.dataType,
		state.mapDataType, nfdrCallback, nfdrDailyCallback, stationMeta, nfdrsDailyFailCount
		, wxHourlyFailCount, nfdrsHourlyFailCount, wxDailyFailCount
	]);

	/* in case calls fail*/
	useEffect(()=>{
		if((nfdrsDailyFailCount>0 || nfdrsDailyFailCount<4) && state.selectedRadio.type==='hourly' && state.selectedRadio.dataType==='FireDanger'&& state.mapDataType==='FireDanger' &&stationMeta){
			nfdrCallback(state.chartTable.value, nfdrsDailyFailCount);
		}
		if((nfdrsDailyFailCount>0 || nfdrsDailyFailCount<4) && state.selectedRadio.type==='daily' && state.selectedRadio.dataType==='FireDanger'&& state.mapDataType==='FireDanger' &&stationMeta){
			nfdrDailyCallback(state.chartTable.value, nfdrsDailyFailCount);
		}
		if((wxHourlyFailCount>0 || wxHourlyFailCount<4) && state.selectedRadio.type==='hourly' && state.selectedRadio.dataType==='Weather'&& state.mapDataType==='Weather' &&stationMeta){
			weatherCallBack(state.chartTable.value, wxHourlyFailCount);
		}
		if((wxDailyFailCount>0 || wxDailyFailCount <4) && state.selectedRadio.type==='daily' && state.selectedRadio.dataType==='Weather'&& state.mapDataType==='Weather'&& stationMeta){
			weatherMinMaxCallback(state.chartTable.value, wxDailyFailCount)
		}
	},[state.chartTable.value, nfdrsDailyFailCount, wxHourlyFailCount,
		wxDailyFailCount, nfdrsHourlyFailCount, nfdrCallback, nfdrDailyCallback,
		weatherCallBack, weatherMinMaxCallback, stationMeta, state.mapDataType, state.selectedRadio.dataType, state.selectedRadio.type
	]);


	/*popuptype will return the popup to be displayed*/
	const PopUpType = useCallback(()=>{
		if(state.selectedRadio.dataType ==='Weather' && state.mapDataType==='Weather'){
			if (state.chartTable.value === 'Hourly_Precipitation' || state.chartTable.value === "Hourly_Solar_Radiation") {
				return (
					<PrecipOrSRHourly all_dates={allVars} />
				);
			}
			else if (state.chartTable.value === 'Hourly_Temp_RH') {
				return (
					<HourlyTempRH all_dates={allVars} />
				);
			}
			else if (state.chartTable.value === "Hourly_Wind") {
				return (
					<WindHourlyChart all_dates={allVars} />
				);
			}
			else if(state.chartTable.value ==='Max_Temp_Min_RH'){
				return(
					<MaxTempRH all_dates={allVars}/>
				)
			}
			else if(state.chartTable.value ==='Min_Temp_Max_RH'){
				return(
					<MinTempRH all_dates={allVars}/>
				)
			}
			else if(state.chartTable.value ==='Max_Wind'){
				return(
					<WindMaxChart all_dates={allVars}/>
				)
			}
			else if(state.chartTable.value ==='Daily_Solar_Radiation' || state.chartTable.value ==='Daily_Precip'){
				return(
					<SRDailyChart all_dates={allVars}/>
				)
			}
			else if (state.chartTable.value === "Hourly_Snow_Flag") {
				return (
					<SFHourly all_dates={allVars} />
				)
			}
			else if (state.chartTable.value === "Snow_Flag") {
				return (
					<SFChart all_dates={allVars} />
				)
			}
			else if (state.chartTable.value==='vapor_press_def'){
				return (<SingleVars all_dates={allVars} type={'hourly'}/>)
			}
			else if(state.chartTable.value==='Max_Min_VPD'){
				return (<DoubleVars all_dates={allVars} type={'daily'}/>)
			}
			else {
				return;
			}
		}

		if(state.selectedRadio.dataType ==='FireDanger' && state.mapDataType==='FireDanger' && state.selectedRadio.type ==='hourly'){
			if (state.chartTable.value === '1_10_FM' || state.chartTable.value === "100_1000_FM" || state.chartTable.value === "herb_woody") {
				return (<DoubleVars all_dates={allVars} type={'hourly'}/>);
			}
			else {
				return (<SingleVars all_dates={allVars} type={'hourly'}/>)
			}
		}
        if(state.selectedRadio.dataType ==='FireDanger' && state.mapDataType==='FireDanger' && state.selectedRadio.type ==='daily'){
            if (state.chartTable.value === '1_10_FM_min' || state.chartTable.value === "100_1000_FM_min" || state.chartTable.value === "herb_woody_max") {
                return (<DoubleVars all_dates={allVars} type={'daily'}/>);
            }
            else {
                return (<SingleVars all_dates={allVars} type={'daily'}/>)
            }
        }
    },[ allVars, state.selectedRadio.dataType, state.chartTable.value, state.mapDataType, state.selectedRadio.type]);

  return(
	<>
	  {PopUpType()}
	</>
  )
};